import CustomText from 'components/common/CustomText/CustomText';
import { colors } from 'styles/colors';

interface Props {
  text: string;
}

export default function CustomCellLabel({ text }: Props) {
  return (
    <CustomText
      text={text}
      fontSize={15}
      fontWeight={600}
      color={colors.secondary}
    />
  )
}
